<template lang="pug">
span
  v-system-bar(v-if="cashRegisterWarningMessage" height="40" app color="error" @click="openDialog")
    .container.text-center.text-subtitle-2.white--text.re-cursor-pointer {{ cashRegisterWarningMessage.title }}

  v-dialog(v-model="dialog" max-width="375")
    v-sheet.rounded-xl.pa-6(v-if="cashRegisterWarningMessage")
      p.text-h3.font-weight-bold.mt-2.mb-5.text-center {{ cashRegisterWarningMessage.title }}

      p.text-subtitle-1.font-weight-bold.mb-1 {{ $t("сообщение_от_офд_name", { fdo: fdoTitle }) }}:
      p.text-subtitle-1.mb-6 {{ fdoMessageTextShort }}

      v-btn.text-h5.font-weight-bold.mb-4(block outlined @click="openDetails") {{ $t("подробнее") }}
      v-btn.text-h5.font-weight-bold(color="primary" block :loading="checking" @click="recheckStatus") {{ $t("проверить_статус_кассы") }}
      v-btn.text-h5.mt-4(block text @click="dialog = false") {{ $t("закрыть") }}
</template>

<script>
import { mapState, mapActions } from 'vuex'
import helpUrls from '../../utils/helpUrls'
import backendErrorMessage from '../../utils/backendErrors'

export default {
  data: () => ({
    dialog: false,
    checking: false,
  }),

  computed: {
    ...mapState({
      cashRegister: state => state.cashRegisters.cashRegister.cashRegister,
    }),

    cashRegisterWarningMessage() {
      if (this.cashRegister.status === 'REGISTERED' && (this.cashRegister.fdoMode === 'OFFLINE' || this.cashRegister.fdoMode === 'BLOCKED')) {
        const isBlocked = this.cashRegister.fdoMode === 'BLOCKED'
        return {
          title: isBlocked ? this.$t('касса_заблокирована') : this.$t('касса_в_автономном_режиме'),
        }
      }
      return null
    },

    fdoMessageText() {
      const text = this.cashRegister.data.fdo?.result?.text
      if (!text) {
        return this.$t('сообщение_отсутствует')
      }
      // Машинные коды вида RESULT_TYPE_DISCONNECTED переводим через общий
      // словарь ошибок бэкенда; человекочитаемые сообщения ОФД - как есть
      const resultType = text.match(/^RESULT_TYPE_([A-Z_]+)$/)
      if (resultType) {
        return backendErrorMessage(resultType[1]) || text
      }
      return text
    },

    // Сообщение от ОФД бывает очень длинным (например, сырые ошибки протокола)
    fdoMessageTextShort() {
      if (this.fdoMessageText && this.fdoMessageText.length > 200) {
        return `${this.fdoMessageText.slice(0, 200)}...`
      }
      return this.fdoMessageText
    },

    // Название конкретного ОФД, чтобы пользователь не путал его сообщения
    // и тариф с сервисным сбором re:Kassa
    fdoTitle() {
      if (this.cashRegister.fdo && this.cashRegister.fdo !== 'REK') {
        return this.$t(`fdo.${this.cashRegister.fdo}.title`)
      }
      return this.$t('офд')
    },
  },

  watch: {
    cashRegisterWarningMessage(newVal) {
      if (!newVal) {
        this.dialog = false
      }
    },
  },

  methods: {
    ...mapActions({
      selectCashRegister: 'cashRegisters/selectCashRegister',
      checkCashRegisterConnection: 'cashRegisters/checkCashRegisterConnection',
      analyticsLogEvent: 'analytics/logEvent',
      showSnackbar: 'tools/showSnackbar',
    }),

    openDialog() {
      this.analyticsLogEvent({ eventName: 're_show_register_offline_blocked_message', eventProperties: { fdoMode: this.cashRegister.fdoMode } })
      this.dialog = true
    },

    openDetails() {
      this.$openLink(helpUrls[this.cashRegister.fdoMode], '_system')
    },

    recheckStatus() {
      this.checking = true
      this.checkCashRegisterConnection(this.cashRegister.id).then((cr) => {
        if (cr.data.fdoMode === 'ONLINE') {
          this.selectCashRegister(this.cashRegister.id).then(() => {
            this.dialog = false
          }).catch((error) => {
            this.showSnackbar({ message: `${this.$t('произошла_ошибка')}: ${error}` })
            this.dialog = false
          })
        } else if (this.fdoMessageText) {
          this.showSnackbar({ message: this.fdoMessageTextShort, timeout: 10000 })
        }
      }).catch((error) => {
        this.showSnackbar({ message: `${this.$t('произошла_ошибка')}: ${error}` })
      }).finally(() => {
        this.checking = false
      })
    },
  },
}
</script>
<style lang="stylus">
</style>
